<template>
  <div>
    <!-- 购物车 -->
    <el-dialog :title="$t('message.shoppingCart')" :close-on-click-modal="false"
      :visible.sync="$parent.shoppingCartDialogVisible" width="1400px" center>
      <div class="body">
        <!-- 列表 -->
        <div class="table">
          <ol>
            <!-- 番号 -->
            <!-- <li class="flex05">{{ $t("message.mash") }}</li> -->
            <!-- 選択 -->
            <li class="flex05">{{ $t("message.sentaku") }}</li>
            <!-- 管理番号 -->
            <!-- <li>{{ $t("message.managementDesignation") }}</li> -->
            <!-- 写真 -->
            <li>{{ $t("message.photo") }}</li>
            <!-- 商品标题 -->
            <li class="flex2">{{ $t("message.commodityTitle") }}</li>
            <!-- 商品属性 -->
            <li class="flex15">{{ $t("message.commodityAttribute") }}</li>
            <!-- 单价 -->
            <li class="flex15">{{ $t("message.unitPrice") }}</li>
            <!-- 数量 -->
            <li>{{ $t("message.quantity") }}</li>
            <!-- 小计 -->
            <li class="flex15">{{ $t("message.subtotal") }}</li>
          </ol>
          <ul v-for="(item, index) in tableData" :key="index">
            <!-- 番号 -->
            <!-- <li class="flex05">{{ item.rowNumber }}</li> -->
            <!-- 選択 -->
            <li class="flex05">
              <el-checkbox v-model="item.checked" @change="changeChecked"></el-checkbox>
            </li>
            <!-- 管理番号 -->
            <!-- <li>{{ item.for_sn }}</li> -->
            <!-- 写真 -->
            <li>
              <el-popover placement="right" width="300" trigger="hover">
                <img :src="item.pic" alt="" style="width: 300px; height: 300px" />
                <a href="JavaScript:;" slot="reference">
                  <el-image :src="item.pic" style="width: 60px; height: 60px; border-radius: 4px">
                    <div slot="placeholder" class="image-slot">
                      加载中<span class="dot">...</span>
                    </div>
                  </el-image>
                </a>
              </el-popover>
            </li>
            <!-- 商品标题 -->
            <li class="flex2">{{ item.goods_title }}</li>
            <!-- 商品属性 -->
            <li class="flex15">
              <div class="attribute">
                <el-tooltip placement="bottom">
                  <div slot="content">
                    <div class="row" v-for="(itemDetail, itemIndex) in item.detail" :key="itemIndex"
                      style="margin-bottom: 5px">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                  <div>
                    <div class="row" v-for="(itemDetail, itemIndex) in item.detail" :key="itemIndex">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                </el-tooltip>
              </div>
            </li>

            <!-- 单价 -->
            <li class="flex15">
              {{ item.price }}
            </li>
            <!-- 数量 -->
            <li>
              {{ item.num }}
            </li>
            <!-- 小计 -->
            <li class="flex15">{{ (item.price * item.num).toFixed(2) }}</li>
          </ul>
          <!-- 暂无数据 -->
          <div v-if="tableData == false" class="No_data">暂无数据</div>
        </div>
        <!--操作-->
        <div class="operation">
          <!-- 全选 -->
          <el-checkbox v-model="checked" @change="allChecked">{{
            $t("message.allChecked")
          }}</el-checkbox>
          <!--  追加到订单-->
          <el-button type="primary" class="fr" @click="submitOrder">{{
            $t("message.addToOrder")
          }}</el-button>
          <!-- 数量 -->
          <div class="fr num">
            {{ $t("message.selected") }}: <span>{{ num }} 件</span>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableData: [],
      checked: false,
      num: 0,
      selectedList: [],
    };
  },
  created() {
    this.previewAddBeCart();
  },
  methods: {
    //购物车
    previewAddBeCart() {
      let datas = {
        user_id: this.$route.query.userID,
        overlook_inventory_ids: [],
      };
      this.$parent.orderDetail.forEach((item) => {
        if (item.id) {
          datas.overlook_inventory_ids.push(item.id);
        }
      });
      if (datas.overlook_inventory_ids == false) {
        datas.overlook_inventory_ids = "";
      }
      this.$api.clienteleApi.previewAddBeCart(datas).then((res) => {
        res.data.forEach((item) => {
          item.goods.forEach((items) => {
            items.checked = false;
            items.fromPlatform = items.shop_type;
            items.goodsId = items.goods_id;
            // items.goodsInfo = items.goods_data.goodsInfo;

            items.option = [];
            this.tableData.push(items);
          });
        });
      });
    },
    //全选
    allChecked() {
      this.num = 0;
      this.selectedList = [];
      this.tableData.forEach((item) => {
        item.checked = this.checked;
      });
      if (this.checked) {
        this.num = this.tableData.length;
        this.selectedList = this.tableData;
      }
    },
    // 单选
    changeChecked() {
      this.num = 0;
      this.selectedList = [];
      this.checked = this.tableData.every((item) => item.checked);
      this.tableData.forEach((item) => {
        if (item.checked) {
          this.selectedList.push(item);
          this.num++;
        }
      });
    },
    // 追加到订单
    submitOrder() {
      if (this.selectedList == false)
        return this.$message.error(
          this.$t("message.selectableOperationalList")
        );
      // 给要添加的列表处理数据
      this.selectedList.forEach((item, index) => {
        item.checked = false;
        item.No = this.$parent.orderDetail.length + index + 1;
        item.order_detail_tag = []
      });
      console.log(this.selectedList);
      // 拼接起来
      this.$parent.orderDetail = [
        ...this.$parent.orderDetail,
        ...this.selectedList,
      ];
      this.$parent.shoppingCartDialogVisible = false;
      //   计算一下费用
      this.$parent.commodityTotal();
    },
  },
};
</script>
<style lang='scss' scoped>
/deep/.el-checkbox__inner {
  transform: scale(2) !important;
}

.table {
  height: 500px;
  overflow-y: auto;

  .flex05 {
    flex: 0.5;
  }

  .flex15 {
    flex: 1.5;
  }

  .flex2 {
    flex: 2;
  }

  .template {
    text-align: center;

    a {
      color: #fa5058;
      text-decoration: underline;
    }
  }

  .attribute {
    width: 100%;
    text-align: left;
    padding: 0 10px;
  }

  .el-icon-sold-out {
    color: #fa5058;
    font-size: 40px;
    cursor: pointer;
  }

  .No_data {
    margin: 20px auto;
    text-align: center;
    font-size: 20px;
  }
}

.operation {
  background-color: #edeff4;
  position: sticky;
  left: 0;
  bottom: 0;
  overflow: hidden;
  padding: 10px 20px;
  height: 40px;
  line-height: 40px;
  border-radius: 6px;
  z-index: 99;
}

.num {
  margin-right: 50px;

  span {
    color: #fa5058;
  }
}
</style>